import type { TableOfContentsUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useDeleteTableOfContentsFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: TableOfContentsUpdatePanelFragment;
};

export function TableOfContentsUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [deleteAttribute] = useDeleteTableOfContentsFromPanelMutation();

  const onSave = async () => {};

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("TableOfContentsUpdatePanel.title")}
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
